import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
/**
 * Component: Blog grid template.
 * ------------------------------------------------------------------------------
 * Template strings used to render the blog article grid.
 *
 * @namespace blogGridTemplate
 */

/**
 * Article card badges HTML markup.
 * @param {Array} tags - API response article tags.
 * @returns {String}
 */

export function articleBadgesHTML(tags) {
  const badges = tags.map(tag => {
    if (tag.includes('related_articles:') || tag.includes('featured')) {
      return '';
    }

    return "\n      <div class=\"article-card__badge badge\">\n        <span>".concat(tag, "</span>\n      </div>");
  }).join('');
  return "\n    <div class=\"article-card__badge-listing\">\n      ".concat(badges, "\n    </div>\n  ");
}
/**
 * Article card image HTML markup.
 * @param {Object} image - API response article image data.
 * @param {Array} tags - API response article tags.
 * @returns {String}
 */

export function articleImageHTML(image, tags) {
  if (!image) {
    return '';
  }

  const imgSizes = ['360x', '540x', '720x', '900x', '1080x', '1296x'];
  const imgSrcArr = [];
  imgSizes.forEach((size, index) => {
    imgSrcArr.push("\n      ".concat(image.transformedSrc.replace('1x', size), "\n      ").concat(Object.keys(window.lazySizesConfig.customMedia)[index] ? "\n        [".concat(Object.keys(window.lazySizesConfig.customMedia)[index], "]\n        ") : '', "\n    "));
  });
  return "\n    <div class=\"article-card__thumbnail-container\">\n      <div\n        class=\"article-card__thumbnail responsive-card-image lazyload\"\n        role=\"img\"\n        aria-label=\"".concat(image.altText, "\"\n        data-bgset=\"").concat(imgSrcArr.join(' | '), "\"\n      ></div>\n      ").concat(articleBadgesHTML(tags), "\n    </div>\n  ");
}
/**
 * Article card HTML markup.
 * @param {Object} node - Article data response node.
 * @returns {String}
 */

export function articleCardHTML(node) {
  return "\n    <a class=\"article-card card\" href=\"".concat(node.onlineStoreUrl, "\">\n      ").concat(articleImageHTML(node.image, node.tags), "\n      <div class=\"article-card__body\">\n        <h3 class=\"article-card__title \">\n          ").concat(node.title, "\n        </h3>\n\n        <p class=\"article-card__subtitle body-2\">\n          ").concat(node.excerpt, "\n        </p>\n\n        <p class=\"text-link\">").concat(theme.strings.blog.read, "</p>\n      </div>\n    </a>\n  ");
}